<!-- CDK virtual scroll: the strategy in pdf-pages-virtual-scroll.ts owns the
     scroll geometry from the known page sizes; only the pages near the
     viewport exist in the DOM. Each canvas renders independently via
     appPdfPageCanvas. templateCacheSize: 0 is load-bearing — wrappers are
     recreated when scrolled back into range, which lets the parent re-inject
     bounding-box overlays via (pageRendered). -->
<cdk-virtual-scroll-viewport class="pdf-container"
    pdfPagesScroll [pageHeights]="pageHeightsPx" [gapPx]="pageGapPx"
    [bufferViewports]="bufferViewports"
    (scrolledIndexChange)="scrolledIndexChange.emit($event)">
  <div *cdkVirtualFor="let page of pageNumbers; trackBy: trackByPageNumber; templateCacheSize: 0"
       class="pdf-page-wrapper is-observing"
       [attr.data-page]="page"
       [style.width]="remOf(pageWidthsPx[page - 1])"
       [style.height]="remOf(pageHeightsPx[page - 1])">
    <div class="pdf-page-spinner" aria-hidden="true">
      <div class="beat-loader">
        <div class="beat"></div>
        <div class="beat"></div>
        <div class="beat"></div>
        <div class="beat"></div>
        <div class="beat"></div>
      </div>
    </div>
    <canvas class="pdf-page-canvas" appPdfPageCanvas
            [pdfDoc]="pdfDoc"
            [pageNum]="page"
            [scale]="pageScales[page - 1]"
            [userRotation]="pageRotations.get(page) || 0"
            (rendered)="pageRendered.emit($event)"></canvas>
  </div>
</cdk-virtual-scroll-viewport>
